import { BaseIcon, BaseIconProps } from './BaseIcon';

export const HomeGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="homeGrad" {...props}>
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="url(#homeGrad)" />
    <polyline points="9 22 9 12 15 12 15 22" stroke="url(#homeGrad)" />
  </BaseIcon>
);
